export const projectTypeOptions = [
  'Client',
  'Support',
  'Project',
  'Consultancy',
  'Security',
  'Infrastructure',
  'Other',
];
